import { fetchBeansList } from '@/api/base/index';

const GET_BEANS_LIST = 'GET_BEANS_LIST';
const FETCH_STATE = 'FETCH_STATE';

const state = () => ({
  list: [],
  fetching: false,
});

const getters = {
  beansList: state => state.list,
};

const actions = {
  fetchBeansList({ state, commit }) {
    if (state.fetching) return;
    commit(FETCH_STATE, true);
    return fetchBeansList().then(res => {
      const list = res.data;
      commit(GET_BEANS_LIST, list);
      commit(FETCH_STATE, false);
    });
  },
};

const mutations = {
  [GET_BEANS_LIST](state, list) {
    state.list = list.map(item => ({ ...item, value: Number(item.value) }));
  },
  [FETCH_STATE](state, fetching) {
    state.fetching = fetching;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
